import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-556d41e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ss-tela-estrutura" }
const _hoisted_2 = { class: "ant-row" }
const _hoisted_3 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_4 = { class: "ant-row" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_6 = { class: "ss-card" }
const _hoisted_7 = { class: "ant-row ss-row-space" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_9 = {
  class: "ss-card",
  style: {"border-bottom-left-radius":"0","border-bottom-right-radius":"0"}
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 2 }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { key: 4 }
const _hoisted_15 = {
  key: 0,
  class: "ant-row ss-row-space"
}
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_17 = { class: "ss-card ss-card-space" }
const _hoisted_18 = {
  key: 0,
  class: "ant-spin-nested-loading"
}
const _hoisted_19 = {
  key: 2,
  class: "ss-sem-dados"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nenhuma informação de origem disponível", -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = {
  class: "ant-row",
  gutter: 24
}
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_24 = { class: "ss-card" }
const _hoisted_25 = {
  key: 0,
  class: "ant-spin-nested-loading"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_30 = {
  key: 0,
  class: "ss-card"
}
const _hoisted_31 = {
  key: 0,
  class: "ant-spin-nested-loading"
}
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titulo_padrao = _resolveComponent("titulo-padrao")!
  const _component_busca_geral = _resolveComponent("busca-geral")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_titulo_padrao, {
          identificadorRecurso: "RASTREABILIDADE_LOTE",
          tituloRecurso: "Rastreabilidade 360° de Lotes",
          exibirAtalhosTela: true,
          exibirHistoricoTela: true,
          empresasSelecionadas: _ctx.telaBase.empresasSelecionadas,
          "onUpdate:empresasSelecionadas": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.telaBase.empresasSelecionadas) = $event))
        }, null, 8, ["empresasSelecionadas"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_busca_geral, {
            empresas: _ctx.telaBase.empresasSelecionadas,
            ordenacao: _ctx.gradeBase.ordenacaoSelecionada,
            "onUpdate:ordenacao": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gradeBase.ordenacaoSelecionada) = $event)),
            "busca-rapida": _ctx.state.buscaRapida,
            "onUpdate:buscaRapida": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.buscaRapida) = $event)),
            "busca-avancada": _ctx.gradeBase.buscaAvancada,
            "onUpdate:buscaAvancada": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.gradeBase.buscaAvancada) = $event)),
            onBuscarDados: _ctx.buscarLotes,
            placeholder: "Digite o lote ou código do produto para buscar"
          }, null, 8, ["empresas", "ordenacao", "busca-rapida", "busca-avancada", "onBuscarDados"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_card, { titulo: "Lotes Rastreados" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                class: "ss-grade",
                columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                "data-source": _ctx.state.lotes,
                "row-key": "id",
                pagination: false,
                loading: _ctx.state.carregandoGrade,
                scroll: { y: _ctx.state.windowHeight },
                size: "small",
                "custom-row": _ctx.customRow,
                "row-class-name": _ctx.obterClasseLinhaLote
              }, {
                bodyCell: _withCtx(({ column, text }) => [
                  (column.dataIndex === 'dataCriacao' || column.dataIndex === 'dataValidade')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                    : (column.dataIndex === 'qtdInicial')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                      : (column.dataIndex === 'saldoAtual')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                        : (column.dataIndex === 'custoTotalEntrada')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                          : (['codigoInterno', 'produtoDescricao', 'lote'].includes(column.dataIndex))
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(text), 1))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [], 64))
                ]),
                emptyText: _withCtx(() => [
                  _createVNode(_component_mensagem_sem_dados, {
                    resultadoPesquisa: !_ctx.state.carregandoGrade,
                    mensagem: "Nenhum lote encontrado..."
                  }, null, 8, ["resultadoPesquisa"])
                ]),
                _: 1
              }, 8, ["columns", "data-source", "loading", "scroll", "custom-row", "row-class-name"])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", {
          class: "resize-handle-y",
          onMousedown: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.initResize && _ctx.initResize(...args)), ["prevent"])),
          title: "Arraste para redimensionar"
        }, null, 32)
      ])
    ]),
    (_ctx.state.loteSelecionado)
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_card, { titulo: "Origem do Lote" }, {
                default: _withCtx(() => [
                  (_ctx.state.origensLoading)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_a_spin)
                      ]))
                    : (_ctx.state.origem)
                      ? (_openBlock(), _createBlock(_component_a_descriptions, {
                          key: 1,
                          column: 5,
                          size: "small",
                          layout: "vertical"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_descriptions_item, {
                              label: "Recurso",
                              style: {"text-align":"left"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.origem.recurso), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_descriptions_item, {
                              label: "Origem",
                              style: {"text-align":"left"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.origem.nomeOrigem), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_descriptions_item, {
                              label: "Documento",
                              style: {"text-align":"center"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.state.origem.documento), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_descriptions_item, {
                              label: "Data",
                              style: {"text-align":"center"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(_ctx.state.origem.data)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_descriptions_item, {
                              label: "Quantidade",
                              style: {"text-align":"right"}
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.UtilitarioMascara.mascararValor(_ctx.state.origem.quantidade, 2)), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createElementBlock("div", _hoisted_19, _hoisted_21))
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_card, { titulo: "Utilizações" }, {
                    default: _withCtx(() => [
                      (_ctx.state.utilizacoesLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_a_spin)
                          ]))
                        : (_openBlock(), _createBlock(_component_a_table, {
                            key: 1,
                            columns: _ctx.gradeUtilizacoes.colunas.filter(item => item.visible),
                            "data-source": _ctx.state.utilizacoes,
                            "row-key": "codigo",
                            pagination: false,
                            size: "small",
                            scroll: { x: 1000, y: 220 },
                            "custom-row": _ctx.customRowUtilizacao,
                            "row-class-name": _ctx.obterClasseLinhaUtilizacao
                          }, {
                            bodyCell: _withCtx(({ column, text }) => [
                              (column.dataIndex === 'data')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                : (column.dataIndex === 'quantidade')
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(text), 1))
                            ]),
                            emptyText: _withCtx(() => [
                              _createVNode(_component_mensagem_sem_dados, {
                                resultadoPesquisa: !_ctx.state.utilizacoesLoading,
                                mensagem: "Nenhuma utilização registrada"
                              }, null, 8, ["resultadoPesquisa"])
                            ]),
                            _: 1
                          }, 8, ["columns", "data-source", "custom-row", "row-class-name"]))
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_ctx.state.mostrarGerados)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                      _createVNode(_component_card, { titulo: "Lotes Gerados" }, {
                        default: _withCtx(() => [
                          (_ctx.state.geradosLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                _createVNode(_component_a_spin)
                              ]))
                            : (_openBlock(), _createBlock(_component_a_table, {
                                key: 1,
                                columns: _ctx.gradeGerados.colunas.filter(item => item.visible),
                                "data-source": _ctx.state.gerados,
                                "row-key": "lote",
                                pagination: false,
                                size: "small",
                                scroll: { x: 1000, y: 220 }
                              }, {
                                bodyCell: _withCtx(({ column, text }) => [
                                  (column.dataIndex === 'dataFabricacao')
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoData(text)), 1))
                                    : (column.dataIndex === 'quantidade')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.UtilitarioMascara.mascararValor(text, 2)), 1))
                                      : (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(text), 1))
                                ]),
                                emptyText: _withCtx(() => [
                                  _createVNode(_component_mensagem_sem_dados, {
                                    resultadoPesquisa: !_ctx.state.geradosLoading,
                                    mensagem: "Nenhum lote gerado encontrado"
                                  }, null, 8, ["resultadoPesquisa"])
                                ]),
                                _: 1
                              }, 8, ["columns", "data-source"]))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}